import { Icon } from "../../../components/icons";
import { MOCK_CATEGORIES, MOCK_ELIM_PLAYERS, MOCK_TOURNAMENT } from "../mockData";
import { publicAsset } from "../publicAsset";
import { Avatar, MockFigure, PhoneFrame } from "./frames";
import "./PlayerHomeMock.css";

/**
 * M9 · Inicio del jugador en su celular: próximo reto, rival, hora y cancha,
 * con los botones reales «WhatsApp» y «Reportar resultado» y el espacio del
 * patrocinador. «Próximo reto», «Hoy juegas por subir.» y «Primer capítulo vs
 * {rival}.» son textos reales de HomeJugadorPage. Se usa en /organizador (D4), en el inicio y en /jugador.
 */

const ME = MOCK_ELIM_PLAYERS.salazar;
const RIVAL = MOCK_ELIM_PLAYERS.aguilar;
const CATEGORY = MOCK_CATEGORIES[0];

const NAV_ITEMS: { label: string; icon: string; active?: boolean }[] = [
  { label: "Inicio", icon: "home", active: true },
  { label: "Torneos", icon: "trophy" },
  { label: "Juegos", icon: "tennis" },
  { label: "Perfil", icon: "user" },
];

export function PlayerHomeMock({ className = "" }: { className?: string }) {
  return (
    <MockFigure
      className={`mk-phome ${className}`.trim()}
      label="Inicio de la app del jugador: su próximo reto contra Tomás Aguilar el sábado 17 de octubre a las 09:00 en la Cancha 1 de la Copa Otoño 2026, con botones para escribirle por WhatsApp y reportar el resultado, y un espacio para el patrocinador."
    >
      <PhoneFrame className="mk-phome__phone">
        <div className="mk-phome__screen">
          <div className="mk-phome__status">
            <span>8:06</span>
            <StatusIcons />
          </div>

          <div className="mk-phome__bar">
            <img
              src={publicAsset("torneos123/icon-torneos123-192.png")}
              alt=""
              width={24}
              height={24}
              loading="lazy"
              decoding="async"
            />
            <strong>Torneos123</strong>
            <span className="mk-phome__bell">
              <Icon name="bell" />
              <i />
            </span>
          </div>

          <div className="mk-phome__hero">
            <span className="mk-phome__eyebrow">
              <Bolt />
              Próximo reto
            </span>
            <span className="mk-phome__title">Hoy juegas por subir.</span>

            <div className="mk-phome__duel">
              <div className="mk-phome__side">
                <Avatar name={ME} className="mk-phome__avatar mk-phome__avatar--me" />
                <small>Tú</small>
                <b>{ME}</b>
              </div>
              <span className="mk-phome__vs">vs</span>
              <div className="mk-phome__side">
                <Avatar name={RIVAL} className="mk-phome__avatar" />
                <small>Rival</small>
                <b>{RIVAL}</b>
              </div>
            </div>

            <div className="mk-phome__when">
              <Icon name="calendar" />
              <span>sáb 17 oct · 09:00 · Cancha 1</span>
            </div>

            <div className="mk-phome__actions">
              <span className="mk-phome__btn mk-phome__btn--chat">
                <ChatBubble />
                WhatsApp
              </span>
              <span className="mk-phome__btn mk-phome__btn--lime">
                <Icon name="clipboard" />
                Reportar resultado
              </span>
            </div>
          </div>

          <div className="mk-phome__rivalry">
            <small>Rivalidad</small>
            <span>Primer capítulo vs {RIVAL}.</span>
          </div>

          <div className="mk-phome__row">
            <span className="mk-phome__tile">
              <Icon name="trophy" />
            </span>
            <span className="mk-phome__row-text">
              <strong>{MOCK_TOURNAMENT.name}</strong>
              <small>{CATEGORY}</small>
            </span>
            <span className="mk-phome__chev" aria-hidden="true">
              ›
            </span>
          </div>

          <div className="mk-phome__sponsor">
            <small>Patrocinador oficial</small>
            <strong>Tu marca aquí</strong>
          </div>

          <div className="mk-phome__nav">
            {NAV_ITEMS.map((item) => (
              <span key={item.label} className={item.active ? "is-active" : undefined}>
                <Icon name={item.icon} />
                {item.label}
              </span>
            ))}
          </div>
        </div>
      </PhoneFrame>
    </MockFigure>
  );
}

function Bolt() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M13.2 2.5 4.8 13.4h6.1l-1.1 8.1 8.4-10.9h-6.1Z" fill="currentColor" />
    </svg>
  );
}

/** Burbuja de chat genérica (no es el logo de WhatsApp). */
function ChatBubble() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M12 4a8 8 0 0 0-6.9 12.05L4 20l4.05-1.08A8 8 0 1 0 12 4Z" />
    </svg>
  );
}

function StatusIcons() {
  return (
    <svg viewBox="0 0 56 12" aria-hidden="true" focusable="false">
      <g fill="currentColor">
        <rect x="0" y="8" width="3" height="4" rx="0.8" />
        <rect x="4.2" y="6" width="3" height="6" rx="0.8" />
        <rect x="8.4" y="4" width="3" height="8" rx="0.8" />
        <rect x="12.6" y="2" width="3" height="10" rx="0.8" />
      </g>
      <g fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
        <path d="M20.4 5.2a8.2 8.2 0 0 1 11.2 0" />
        <path d="M22.8 7.7a4.6 4.6 0 0 1 6.4 0" />
      </g>
      <circle cx="26" cy="10.4" r="1.3" fill="currentColor" />
      <rect x="36" y="1.5" width="16.5" height="9" rx="2.6" fill="none" stroke="currentColor" strokeOpacity="0.55" strokeWidth="1.1" />
      <rect x="37.7" y="3.2" width="11.6" height="5.6" rx="1.3" fill="currentColor" />
      <rect x="53.4" y="4.5" width="1.6" height="3" rx="0.7" fill="currentColor" fillOpacity="0.55" />
    </svg>
  );
}
